class AuditorsDelegate {
    setRows(rows) {
        this.setState({ rows });
    }
}

export default AuditorsDelegate;
